import { el } from "@utils/dom";
import { getState, setState, subscribe } from "@state/store";

/**
 * Mode toggle component for switching between Groups and Seating Chart modes
 */
export function createModeToggle(): HTMLElement {
    const container = el("div", { class: "mode-toggle" });

    const groupsBtn = el("button", { "data-mode": "groups" }, "Groups");
    const seatingBtn = el("button", { "data-mode": "seating" }, "Seating Chart");

    function updateActiveState() {
        const s = getState();
        const cls = s.classes.find(c => c.id === s.activeClassId);
        const mode = cls?.settings.mode ?? 'groups';

        groupsBtn.classList.toggle('active', mode === 'groups');
        seatingBtn.classList.toggle('active', mode === 'seating');
    }

    groupsBtn.addEventListener("click", () => {
        setState(ns => {
            const cls = ns.classes.find(c => c.id === ns.activeClassId);
            if (cls) cls.settings.mode = 'groups';
        });
        document.dispatchEvent(new CustomEvent("mode:change", { detail: { mode: 'groups' } }));
    });

    seatingBtn.addEventListener("click", () => {
        setState(ns => {
            const cls = ns.classes.find(c => c.id === ns.activeClassId);
            if (cls) cls.settings.mode = 'seating';
        });
        document.dispatchEvent(new CustomEvent("mode:change", { detail: { mode: 'seating' } }));
    });

    container.append(groupsBtn, seatingBtn);

    // Initial state
    updateActiveState();

    // Subscribe to state changes
    subscribe(updateActiveState);

    return container;
}

/**
 * Get current mode for the active class
 */
export function getCurrentMode(): 'groups' | 'seating' {
    const s = getState();
    const cls = s.classes.find(c => c.id === s.activeClassId);
    return cls?.settings.mode ?? 'groups';
}
